<template>
  <div>
    <div v-if="!dataLoaded">
      <v-progress-circular indeterminate color="primary" class="ret-center-absolute"></v-progress-circular>
    </div>
    <div class="ret-cards-wrapper" v-if="dataLoaded">
      <v-card class="ret-card">
        <v-card-title>
          <h3 class="headline">{{ $tc('issue-codes.entity-name', 1) }}</h3>
          <v-spacer></v-spacer>
          <v-btn
            v-if="editedItem.id"
            text
            color="warn"
            @click="onDestroy(editedItem)"
            data-test="issue-code-archive"
          >{{ $t('archive') }}</v-btn>
        </v-card-title>
        <v-card-text>
          <form>
            <v-text-field
              v-model="editedItem.code"
              :label="$t('issue-codes.code')"
              :error-messages="itemErrors.code"
              data-test="new-issue-code-code"
            ></v-text-field>
            <v-text-field
              v-model="editedItem.name"
              :label="$t('name')"
              :error-messages="itemErrors.name"
              data-test="new-issue-code-name"
            ></v-text-field>
          </form>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="$router.go(-1)">{{ $t('back') }}</v-btn>
          <v-spacer />
          <v-btn
            @click="handleSaveClick"
            color="primary"
            :disabled="!isUnsaved"
            data-test="new-issue-code-save"
          >{{ $t('save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
import displayHelpers from '../helpers/display-helpers.es6'
import itemHelpers from '../helpers/item-helpers.es6'

export default {
  mixins: [displayHelpers, itemHelpers],
  data: function () {
    return {
      model: { name: 'issue-codes' }
    }
  }
}
</script>
